// BDSJEA-444: opciones de la busqueda de productores (orden, limite, tamanio de pagina). Los valores de `orden` y
// `sentido` son los del contrato del backend (GET /productores/busqueda).

export const ORDENES = [
  { valor: "nombre", etiqueta: "Nombre" },
  { valor: "cuit", etiqueta: "CUIT" },
  { valor: "fechaAlta", etiqueta: "Fecha de alta" },
  { valor: "tipo", etiqueta: "Tipo de productor" },
]

export const SENTIDOS = [
  { valor: "asc", etiqueta: "Ascendente" },
  { valor: "desc", etiqueta: "Descendente" },
]

// limite 0 = «Todos» (el servidor lo acota).
export const LIMITES = [
  { valor: 100, etiqueta: "100" },
  { valor: 500, etiqueta: "500" },
  { valor: 1000, etiqueta: "1.000" },
  { valor: 5000, etiqueta: "5.000" },
  { valor: 0, etiqueta: "Todos" },
]

export const TAMANIOS_PAGINA = [10, 25, 50, 100]

export const OPCIONES_INICIALES = {
  orden: "nombre",
  sentido: "asc",
  limite: 1000,
  size: 100,
  pagina: 0,
}

// Entero con separador de miles «.» (independiente del ICU del entorno).
export const formatearEntero = n =>
  String(Math.trunc(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ".")

export const etiquetaOrden = valor =>
  (ORDENES.find(o => o.valor === valor) || { etiqueta: valor }).etiqueta

export const etiquetaLimite = valor =>
  (LIMITES.find(l => l.valor === valor) || { etiqueta: String(valor) }).etiqueta

// «orden Nombre ↑ · límite 1.000 · 100 por página»
export const resumenOpciones = ({ orden, sentido, limite, size }) =>
  `orden ${etiquetaOrden(orden)} ${sentido === "desc" ? "↓" : "↑"} · límite ${etiquetaLimite(limite)} · ${size} por página`
